import { useMutation } from '@apollo/client';
import { DELETE_EMPLOYEE, EMPLOYEES } from '@src/graphql/queries/employee';
// eslint-disable-next-line import/no-extraneous-dependencies
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useEmployees = ({ id, clientId, searchText, onlySignedUp }) => {
    const { page, setPage, pageSize, setPageSize, orderBy, setOrderBy, orderByDir, setOrderByDir, total, items: employees, loading, error, find, } = usePaginatedFetchItems({
        spec: { id, clientId, searchText, onlySignedUp },
        fetchQuery: EMPLOYEES,
        dataProp: 'employees',
        initialPageSize: 10,
        skip: !clientId,
    });
    const [deleteEmployee] = useMutation(DELETE_EMPLOYEE, {
        refetchQueries: [EMPLOYEES],
    });
    return {
        employees,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        orderBy,
        setOrderBy,
        orderByDir,
        setOrderByDir,
        error,
        total,
        find,
        deleteEmployee,
    };
};
